import { render, staticRenderFns } from "./bottomPopup.vue?vue&type=template&id=b54b3fe4&scoped=true"
import script from "./bottomPopup.vue?vue&type=script&lang=js"
export * from "./bottomPopup.vue?vue&type=script&lang=js"
import style0 from "./bottomPopup.vue?vue&type=style&index=0&id=b54b3fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b3fe4",
  null
  
)

export default component.exports